RivalIQ.apps.Discovery.module('views', function (views, App, Backbone, Marionette) {
    'use strict';

    views.RecommendationItemView = RivalIQ.views.ItemView.mixin({
        template: '#discoveryRecommendationTemplate',

        className: 'recommendation',

        events: {
            'click': 'onClick'
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        initialize: function () {
            const me = this;

            me.channel = me.options.channel;
            me.type = me.options.type;
            me.searchTerm = me.options.searchTerm;
            me.value = me.options.value;
            me.dashboardModel = me.options.dashboardModel;
        },

        onClick: function () {
            const me = this;

            const url = RivalIQ.apps.Dashboard.router.router.resolveCurationRoute(RivalIQ.enums.curation.DISCOVERY, {
                searchTerm: me.searchTerm,
                searchType: App.enums.searchTypes.TOP,
                channel: me.channel
            });

            RivalIQ.execute('history:navigate', url, {
                trigger: true
            });
        },

        templateHelpers: function () {
            const me = this;

            let recommendationText = RivalIQ.str('discovery_recommendation_my_content');

            if (me.type === 'top-hashtag') {
                recommendationText = RivalIQ.str('discovery_recommendation_hashtag', me.value);
            } else if (me.type === 'top-mentioned') {
                recommendationText = RivalIQ.str('discovery_recommendation_competitor_content', me.value);
            }

            return {
                recommendationText: recommendationText
            };
        }
    });

    views.RecommendationsView = RivalIQ.views.CompositeView.extend({
        template: '#discoveryRecommendationsTemplate',

        childViewContainer: '.x-recommendations-list',

        childView: views.RecommendationItemView,

        childViewOptions: function (model) {
            const me = this;

            return {
                type: model.get('type'),
                channel: model.get('channel'),
                searchTerm: model.get('searchTerm'),
                value: model.get('value'),
                dashboardModel: me.options.dashboardModel
            };
        }
    });
});
